"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Item = _interopRequireDefault(require("./Item"));
var _utils = require("./utils");
var _jsxFileName = "/home/builduser/work/b60d7defec63c7cc/packages/wix-style-react/dist/cjs/NestableListBase/Container.js";
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
class Container extends _react.Component {
  render() {
    var {
      items,
      parentPosition,
      childrenProperty,
      childrenStyle,
      renderAction,
      treeDepth,
      isParentLastItem = true,
      isRenderDraggingChildren,
      topLevel,
      theme
    } = this.props;
    var containerClass;
    if (theme) {
      containerClass = topLevel && theme.topContainer || theme.container;
    }
    var classes = (0, _classnames.default)('nestable-container', {
      'nestable-top-container': topLevel
    }, containerClass);
    return /*#__PURE__*/_react.default.createElement("div", {
      className: classes,
      style: topLevel ? {} : childrenStyle,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 32,
        columnNumber: 7
      }
    }, items.map((item, i) => {
      var position = parentPosition.concat([i]);
      var children = item[childrenProperty] && item[childrenProperty].map(child => {
        if (item.lockDropArea || item.isParentLocked) {
          child.isParentLocked = true;
          child.draggable = false;
        }
        return child;
      });
      var hasChildren = children && children.length;
      var isLastItem = items.length - 1 === i;
      var actionButton = renderAction({
        siblings: items,
        item,
        veryLastItem: isLastItem && isParentLastItem,
        depth: treeDepth
      });
      var veryLastItem = isLastItem && isParentLastItem && (!hasChildren || item.isCollapsed) && !actionButton;
      return /*#__PURE__*/_react.default.createElement(_Item.default, {
        id: item.id,
        key: item.id,
        item: item,
        index: i,
        isVeryLastItem: veryLastItem,
        siblings: items,
        isRenderDraggingChildren: isRenderDraggingChildren,
        position: position,
        depth: (0, _utils.getDepth)(item, childrenProperty),
        theme: theme,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 60,
          columnNumber: 13
        }
      }, !item.isCollapsed && /*#__PURE__*/_react.default.createElement("div", {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 73,
          columnNumber: 17
        }
      }, hasChildren ? /*#__PURE__*/_react.default.createElement(WrappedContainer, {
        isParentLastItem: isLastItem && isParentLastItem && !actionButton,
        items: children,
        renderAction: renderAction,
        isRenderDraggingChildren: isRenderDraggingChildren,
        parentPosition: position,
        childrenProperty: childrenProperty,
        childrenStyle: childrenStyle,
        theme: theme,
        treeDepth: treeDepth + 1,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 75,
          columnNumber: 21
        }
      }) : null, actionButton));
    }));
  }
}
class WrappedContainer extends _react.default.PureComponent {
  render() {
    return /*#__PURE__*/_react.default.createElement(Container, (0, _extends2.default)({}, this.props, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 102,
        columnNumber: 12
      }
    }));
  }
}
var _default = exports.default = WrappedContainer;
//# sourceMappingURL=Container.js.map